import { render, staticRenderFns } from "./StatisticsPanel.vue?vue&type=template&id=3e8c9226&"
import script from "./StatisticsPanel.vue?vue&type=script&lang=js&"
export * from "./StatisticsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports